import { postLogs } from "../../api-sdk/v3/routes";
import { paths } from "../../api-sdk/v3/openapi-spec";
import { logger } from "../../utils/logger";
import { DEFAULT_LOG_URL } from "../../api-sdk/constants";

type PostLogsReq = paths["/logs"]["post"]["requestBody"]["content"]["application/json"];

interface SendLogConfig {
  apiKey: string;
  baseUrl?: string;
}

export async function sendLog(config: SendLogConfig, payload: PostLogsReq): Promise<void> {
  const { apiKey, baseUrl } = config;
  try {
    await postLogs({
      baseUrl: baseUrl || DEFAULT_LOG_URL,
      headers: {
        authorization: `Api-Key ${apiKey}`,
      },
      requestBody: {
        ...payload,
      },
    });
  } catch (err) {
    logger.error("Failed to send log", err);
  }
}
